import * as types from 'reducer/actionTypes'
import { removeTrailingSlash } from 'script/common';
import Account from 'components/account/Account';
import License from 'components/license/License';
import Adapter from 'components/adapter/Adapter';
import Stats from 'components/stats/Stats';
import Setting from 'components/setting/Setting';
import Monitoring from 'components/monitoring/Monitoring';

const initialState = {
	basename: "",
	submenus:[
		{
			menu: "menu.title.account",
			path: "/account",
			className : "nav_account",
			component: Account
		},
		{
			menu: "menu.title.license",
			path: "/license",
			className : "nav_license",
			component: License
		},
		{
			menu: "menu.title.adapter",
			path: "/connect",
			className : "nav_connect",
			component: Adapter
		},
		{
			menu: "menu.title.stats",
			path: "/stats",
			className : "nav_stats",
			component: Stats
		},
		{
			menu: "menu.title.setting",
			path: "/setting",
			className : "nav_setting",
			component: Setting
		},
		{
			menu: "menu.title.monitoring",
			path: "/monitoring",
			className : "nav_stats",
			component: Monitoring
		}
	]
};


export default function main(state = initialState, action){
	switch(action.type){
		case types.GET_BASENAME :
			return state.basename

		case types.SET_BASENAME :
			const pathname = window.location.pathname;
			const matchingSubmenu = state.submenus.find(data => pathname.includes(data.path));
			
			let basePath = pathname;
			if (matchingSubmenu) {
				const indexOfPath = pathname.indexOf(matchingSubmenu.path);
				if (indexOfPath !== -1) {
					const indexPath = pathname.substring(0, indexOfPath);
					basePath = indexPath;
				}
			}

			return{
				...state,
				basename: removeTrailingSlash(basePath)
			}

		default:
			return state
	}
}